import { UserRoles } from '../store/models/User';

export const isVendorRole = (roles: UserRoles[] | null) => {
  if (!roles) {
    return null;
  }

  return roles?.some((role) => [UserRoles.VENDOR_TL, UserRoles.VENDOR_VIEWER].includes(role));
};
